<template>
  <div id="itembank-form">
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>Content Section</li>
      <li class="active">Create</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Tambah Konten</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">Form Content</h4>
          </div>
          <div class="panel-body panel-form">
            <div class="alert alert-danger fade in m-b-15" v-if="this.errors.length > 0">
              <span class="close" data-dismiss="alert">&times;</span>
              <strong>Terjadi kesalahan!</strong>
              <ul>
                <li v-for="(message, key) in this.errors" v-bind:key="key">{{message}}</li>
              </ul>
            </div>
            <form class="form-horizontal form-bordered">
              <div class="form-group" v-bind:class="{ 'has-error': errors.indexOf('type') >= 0 }">
                <label class="col-md-2 control-label">Type</label>
                <div class="col-md-8 col-xs-12">
                  <select class="form-control" v-model="form.type" :disabled="$route.query.id ? true : false">
                    <option value="SINGLE_BANNER">Single Banner</option>
                    <option value="MULTIPLE_BANNER">Multiple Banner</option>
                    <option value="EXERCISE">Latihan Soal</option>
                    <option value="ONGOING_TRYOUT">Tryout Berlangsung</option>
                    <option value="TRYOUT_RESULT">Hasil Tryout</option>
                    <option value="VIDEO">Video</option>
                    <option value="ARTICLE">Artikel</option>
                  </select>


                  <div v-if="form.type === 'VIDEO'" class="alert alert-warning mt-2" role="alert"><b>Perhatian!</b> semua konten dengan type 'Video' akan diisi video/detail yang sama secara otomatis oleh sistem</div>
                </div>
              </div>
              <div class="form-group" v-bind:class="{ 'has-error': errors.indexOf('name') >= 0 }">
                <label class="col-md-2 control-label">Judul *</label>
                <div class="col-md-8 col-xs-12">
                  <input class="form-control" type="text" maxlength="50" v-model="form.name"/>
                </div>
              </div>
               <div class="form-group">
                 <label class="col-md-2 control-label"></label>
                 <div class="col-md-8 col-xs-12">
                  <button v-if="$route.query.id" type="button" class="btn btn-success btn-md" @click="save()">Simpan Perubahan</button>
                  <button v-else type="button" class="btn btn-success btn-md" @click="save()">Simpan</button>
                 </div>
               </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentService from '@/services/content.js'

export default {
  name: 'content-article-form',
  components: {
  },
  data: function() {
    return {
      compiledContent: '',
      labelQuery: '',
      form: {
        id: 0,
        name: null,
        type: null,
        is_active: true,
        status: null,
        order_number: 0
      },
      errors: []
    }
  },
  mounted: function () {
    if (this.$route.query.id) {
      this.queryId = this.$route.query.id
      this.fetchData()
    }
  },
  methods: {
    fetchData: function () {
			var data = this.$store.state.content.editContent
      this.form = {
        id: 0,
        name: data.data[0],
        type: data.data[1],
        is_active: false,
        status: 'HIDDEN',
        order_number: 0
      }
		},
    save: function() {
      var context = this
      if(this.validateForm()) {

        if(!this.$route.query.id) {
          this.form.status = 'HIDDEN'
          this.form.order_number = 0
          ContentService.contentSectionCreate(this.form, function(result) {
            if(result.success) {
              alert('data telah tersimpan')
              context.$router.push({path: '/content/section'})
            } else {
              alert('Terjadi kesalahan: ' + result.message)
            }
          })
        } else {
          ContentService.contentSectionUpdate(this.$route.query.id, this.form, function(result) {
            if(result.success) {
              alert('data telah diubah')
              context.$router.push({path: '/content/section'})
            }
            else {
              alert('Terjadi kesalahan: ' + result.message)
            }
          })
        }
      }
    },
    validateForm: function() {
      this.errors = []
      if(!this.form.name) this.errors.push('Judul konten wajib diisi')
      if(!this.form.type) this.errors.push('Type konten wajib diisi')

      if(this.errors.length == 0) return true

      return false
    },
  }
}
</script>



// WEBPACK FOOTER //
// Form.vue?7b731aef